import { render, staticRenderFns } from "./UrlInstanceRender.vue?vue&type=template&id=5d36f09c&scoped=true"
import script from "./UrlInstanceRender.vue?vue&type=script&lang=js"
export * from "./UrlInstanceRender.vue?vue&type=script&lang=js"
import style0 from "./UrlInstanceRender.vue?vue&type=style&index=0&id=5d36f09c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d36f09c",
  null
  
)

export default component.exports